import { render, staticRenderFns } from "./dashboardComponent.vue?vue&type=template&id=893d45d8&scoped=true"
import script from "./dashboardComponent.vue?vue&type=script&lang=js"
export * from "./dashboardComponent.vue?vue&type=script&lang=js"
import style0 from "./dashboardComponent.vue?vue&type=style&index=0&id=893d45d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893d45d8",
  null
  
)

export default component.exports